import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { IAtgardPrimaryKey } from "../atgard/AtgardBaseCommand";

export abstract class VirkeskostnadBaseCommand extends BasicCommand<VirkeskostnadBaseCommand> {
    virkeskopskontraktGuid?: string;
    virkeskopsatgardGuid?: string;
    guid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "virkeskostnader";

    get primaryKey(): IVirkeskostnadPrimaryKey {
        return {
            guid: this.guid,
            atgardGuid: this.virkeskopsatgardGuid,
            kontraktGuid: this.virkeskopskontraktGuid
        };
    }
    constructor($type, commandType) {
        super($type, VirkeskostnadBaseCommand.$groupKey, commandType);
    }
}

export interface IVirkeskostnadPrimaryKey extends IAtgardPrimaryKey {
    guid: string;
}
